export default {
  check_status: {
    verified: 'Vahvistettu',
    pending: 'Odottaa',
    failed: 'Epäonnistui',
    not_applicable: 'Ei tarvita',
    required: 'Pakollinen',
  },
  records: {
    type: 'Tyyppi',
    name: 'Nimi',
    value: 'Arvo',
    status: 'Tila',
    certificate: 'Varmenne',
    certificate_hint: 'Myönnetään automaattisesti, kun yllä olevat tietueet löytyvät.',
    full_name: 'Koko nimi:',
  },
  check_hint: {
    found: 'Löytyi {{values}} sen sijaan. Korvaa se näytetyllä arvolla.',
    missing: 'Tätä tietuetta ei löytynyt.',
    certificate: 'Varmennetta ei voitu myöntää. Korjaa yllä merkityt tietueet ja tarkista uudelleen.',
    certificate_unknown:
      'Varmennetta ei voitu myöntää. Tarkista myöhemmin uudelleen ja ota yhteyttä tukeen, jos tilanne jatkuu.',
    regressed: 'Tämä tietue oli aiemmin vahvistettu, mutta sitä ei enää löydy.',
    technical: 'Tekninen tieto: {{error}}',
    held_by_another_project:
      '{{name}} on toisen Vercel-verkkosivuston käytössä, joten se ei voi ohjata kävijöitä kauppaan osoitteessa www.{{name}}. Jotta {{name}} avaa myös kaupan, poista verkkotunnus ensin kyseiseltä toiselta sivustolta.',
    certificate_pending: {
      not_attached: 'Käynnissä: verkkotunnusta lisätään parhaillaan meidän puolellamme.',
      awaiting_dns: 'Käynnissä: varmenne myönnetään, kun yllä olevat tietueet löytyvät.',
      awaiting_certificate:
        'Käynnissä: tietueet osoittavat meille, ja varmennetta ollaan myöntämässä. Tämä kestää yleensä muutaman minuutin.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} on yhdistetty myös toiseen Vercel-tiliin. Todistaaksesi, että se on sinun, lisää alla olevat TXT-tietueet myös DNS-palveluntarjoajalle ja tarkista sitten uudelleen.',
      held_by_another_project:
        'Toinen Vercel-verkkosivusto käyttää jo verkkotunnusta {{name}}. Poista verkkotunnus ensin kyseiseltä sivustolta ja tarkista uudelleen — tai käytä toista verkkotunnusta.',
      dns_correct_but_unconfigured:
        "Yllä olevat tietueet ovat oikein, mutta jokin muu osoitteessa {{name}} estää varmenteen. Poista mahdollinen AAAA-tietue, poista käytöstä mahdollinen välityspalvelin (kuten Cloudflaren oranssi pilvi) ja varmista, ettei mikään CAA-tietue sulje pois Let's Encryptiä. Tarkista sitten uudelleen.",
      name_mismatch:
        '{{name}} vastaa varmenteella, joka on myönnetty nimelle {{names}}. Varmista, että yllä olevat tietueet ovat ainoat osoitteessa {{name}}; jos näin on, ota yhteyttä tukeen.',
      name_mismatch_unnamed:
        '{{name}} vastaa varmenteella, joka on myönnetty toiselle nimelle. Varmista, että yllä olevat tietueet ovat ainoat osoitteessa {{name}}; jos näin on, ota yhteyttä tukeen.',
      expired:
        'Varmenne on vanhentunut, eikä sitä uusittu. Meille on ilmoitettu asiasta ja käsittelemme sitä — ei toimenpiteitä toistaiseksi.',
      expiring:
        'Varmenne vanhenee pian, eikä sitä ole vielä uusittu. Käsittelemme asiaa — ei toimenpiteitä toistaiseksi.',
      attach_refused:
        'Hosting-palveluntarjoajamme kieltäytyi lisäämästä {{name}} meidän puolellamme. Meille on ilmoitettu asiasta ja selvitämme sitä — ei muutoksia DNS-palveluntarjoajalla toistaiseksi.',
    },
    certificate_overdue: {
      not_attached:
        '48 tunnin jälkeen verkkotunnusta ei edelleenkään saatu lisättyä meidän puolellamme. Ota yhteyttä tukeen.',
      awaiting_dns:
        'Yllä olevia tietueita odotetaan yhä 48 tunnin jälkeen. Korjaa merkityt tietueet ja tarkista uudelleen.',
      awaiting_dns_records_verified:
        'Ei vieläkään myönnetty 48 tunnin jälkeen, vaikka yllä olevat tietueet on vahvistettu. Ota yhteyttä tukeen.',
      awaiting_certificate:
        'Tietueet osoittavat meille, mutta varmennetta ei ole vieläkään myönnetty 48 tunnin jälkeen. Ota yhteyttä tukeen.',
    },
    certificate_dates: {
      valid_until: 'Voimassa {{date}} asti.',
      expires_on: 'Vanhenee {{date}}.',
      expired_on: 'Vanhentui {{date}}.',
    },
  },
};
